import React from 'react';

interface AvatarPlaceholderProps {
  initials: string;
  size?: number;
}

const AvatarPlaceholder: React.FC<AvatarPlaceholderProps> = ({ initials, size = 200 }) => {
  const fontSize = size * 0.38;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
      style={{ borderRadius: '50%' }}
    >
      <rect width={size} height={size} rx={size / 2} fill="#1a1a1a" />
      <text
        x="50%"
        y="50%"
        dominantBaseline="central"
        textAnchor="middle"
        fill="#ffffff"
        fontSize={fontSize}
        fontFamily="'Fellix-Bold', 'Inter', sans-serif"
        fontWeight="700"
        letterSpacing="0.05em"
      >
        {initials}
      </text>
    </svg>
  );
};

export default AvatarPlaceholder;
